var styleDataHash = 'a71588ea';  
export const injectCss = (() => {
  var css = `[dir] .FtB2t{border:1px solid #000}.gYB5J{height:33.75%;width:60%}.SOslO{height:45%;width:60%}.UYjQc{height:60%;width:60%}.rm2OV{height:60%;width:45%}.DZiX4{height:60%;width:33.75%}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "imageRatioSelector_ratioIcon": "FtB2t",
  "imageRatioSelector_16_9": "gYB5J",
  "imageRatioSelector_4_3": "SOslO",
  "imageRatioSelector_1_1": "UYjQc",
  "imageRatioSelector_3_4": "rm2OV",
  "imageRatioSelector_9_16": "DZiX4"
};